export default class DetailUtil {

    static checkDuplicatePositions(details, isOptimization) {

        const positions = new Map();
        const names = []
        for (const detail of details) {

            const position = detail.position;

            if (positions.has(position)) {
                let error = !DetailUtil.equals(detail, positions.get(position), isOptimization);

                if (error) {
                    names.push(detail.position)
                }
            } else {
                positions.set(position, detail);
            }
        }

        return names;
    }

    static checkDuplicateNames(details) {
        const groupedByName = details.reduce((acc, obj) => {
            // Same visible name as in estimate tables (catalog name or temp*)
            const name = obj.materialOrganizationOption?.name || obj.tempName || obj.name;
            if (!name) {
                return acc;
            }

            if (!acc[name]) {
                acc[name] = [];
            }
            acc[name].push(obj.id);
            return acc;
        }, {});

        return Object.values(groupedByName).filter(group => group.length > 1).flat();
    }

    static isDuplicateEstimateRow(errorIds, isFact, rowId) {
        const currError = isFact ? errorIds?.isFact : errorIds?.isCalc;
        if (!currError?.length || rowId == null) {
            return false;
        }
        const id = String(rowId);
        return currError.some((errorId) => String(errorId) === id);
    }


    static checkDuplicateNamesAndOrder(materials) {
        const groupedByNamesAndOrder = materials.reduce((acc, material) => {
            if (!material?.materialName || !material?.orderNumbers) return acc

            const nameKey = `${material?.materialName} ${material?.orderNumbers}`;
            if (!acc[nameKey]) {
                acc[nameKey] = [];
            }
            acc[nameKey].push(material.id);
            return acc;
        }, {});

        return Object.values(groupedByNamesAndOrder).filter(group => group.length > 1).flat()

    }

    static calcPair = (detail) => {
        const lPair = [detail.l1, detail.l2].sort().join("_")
        const wPair = [detail.w1, detail.w2].sort().join("_")
        return {lPair, wPair}
    }

    static equals(detail1, detail2, isOptimization) {
        const pairsInDetail1 = DetailUtil.calcPair(detail1)
        const pairsInDetail2 = DetailUtil.calcPair(detail2)

        if (isOptimization) {
            if (detail1.materialOptionOrganizationName !== detail2.materialOptionOrganizationName) {
                return true
            }
            if (detail1.modified.toString() === 'true') {
                return true
            }

            if (detail2.modified.toString() === 'true') {
                return true
            }

        } else {
            if (detail1.materialName !== detail2.materialName) {
                return true
            }
        }

        if (detail1.length !== detail2.length) {
            return false;
        }
        if (detail1.height !== detail2.height) {
            return false;
        }
        if (detail1.turn !== detail2.turn) {
            return false;
        }
        if (pairsInDetail1.lPair !== pairsInDetail2.lPair) {
            return false;
        }
        if (pairsInDetail1.wPair !== pairsInDetail2.wPair) {
            return false;
        }
        if (detail1.reserveLimit !== detail2.reserveLimit) {
            return false;
        }
        if (detail1.materialOptionOrganizationId !== detail2.materialOptionOrganizationId) {
            return false;
        }
        return detail1.groove === detail2.groove;
    }

    static compareEqual(row1, row2) {

        if (row1.position !== row2.position) {
            return false;
        }

        if (row1.name !== row2.name) {
            return false;
        }
        if (row1.length !== row2.length) {
            return false;
        }
        if (row1.width !== row2.width) {
            return false;
        }
        if (row1.quantity !== row2.quantity) {
            return false;
        }
        if (row1.reserveLimit !== row2.reserveLimit) {
            return false;
        }

        if (row1.turn !== row2.turn) {
            return false;
        }
        if (row1.l1 !== row2.l1) {
            return false;
        }
        if (row1.w1 !== row2.w1) {
            return false;
        }
        if (row1.w2 !== row2.w2) {
            return false;
        }
        if (row1.materialOptionOrganizationId !== row2.materialOptionOrganizationId) {
            return false;
        }

        return row1.groove === row2.groove;
    }

    static getDefaultAttribute(attributes) {
        let defaultAttribute;
        for (const attribute of attributes) {
            if (attribute.enabledDefault) {
                defaultAttribute = attribute;
                break;
            }
        }
        return defaultAttribute
    }
}